import { render, staticRenderFns } from "./CardMosaicoGaleria.vue?vue&type=template&id=297052fc&scoped=true"
import script from "./CardMosaicoGaleria.vue?vue&type=script&lang=js"
export * from "./CardMosaicoGaleria.vue?vue&type=script&lang=js"
import style0 from "./CardMosaicoGaleria.vue?vue&type=style&index=0&id=297052fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297052fc",
  null
  
)

export default component.exports